import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "app-modal-logout",
  templateUrl: "./modal-logout.component.html",
  styleUrls: ["./modal-logout.component.scss"],
})
export class ModalLogoutComponent implements OnInit {
  @Output() close = new EventEmitter<string>();
  @Output() dismiss = new EventEmitter<string>();

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}

  onClose(message: string) {
    localStorage.clear();
    sessionStorage.clear();
    this.close.emit(message);
    this.activeModal.close();
    window.location.href = environment.sieni + "/auth/login";
  }

  onDismiss(message: string) {
    this.dismiss.emit(message);
    this.activeModal.dismiss();
  }
}
